import React, { Component } from "react";
import SaveForLater from "./save-for-later";
import PropTypes from "prop-types";
import requester from "modules/requester";
import analytics from "analytics/analytics";
import saveForLaterUtils from "./save-for-later-utils";

const TYPE = "product_card";

class ToggleSaveSFLB extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isSaving: false,
            isSaved: false,
            isInitialised: false
        };

        this.onClick.bind(this);
        this.isSaved.bind(this);
    }

    componentDidMount() {
        this.isSaved(this.props.productId);
    }

    async isSaved(productId) {
        if (!this.state.isInitialised) {
            try {
                const isSaved = await saveForLaterUtils.fetchSaveForLaterPins(productId);
                this.setState({ isSaved, isInitialised: true });
            } catch (err) {
                console.error(err);
            }
        }
    }

    onClick() {
        if (this.state.isSaving) {
            return;
        }

        this.setState({ isSaving: true });

        const method = "POST";
        const body = {
            product_id: this.props.productId
        };

        return requester("/services/pins/", { method, body })
            .then(response => {
                if (!response.ok) {
                    console.error(
                        `Could not save/un-save product with id: ${this.options.productId}`
                    );
                    return;
                }

                if (response.status === 204) {
                    // product removed from save-for-later
                    analytics.event("save_for_later", "remove_item", TYPE);
                    this.setState({ isSaving: false, isSaved: false });
                } else if (response.status === 201) {
                    // product added to save-for-later
                    analytics.event("save_for_later", "add_item", TYPE);
                    this.setState({ isSaving: true, isSaved: true });
                }

                this.setState({ isSaving: false });
            })
            .catch(e => {
                this.setState({ isSaving: false });

                // Still want to log the intent, but can't work out from response if it was an add or remove
                // - get this data from the state instead (this won't be accurate if the page
                // has not been refreshed since last add/remove, but is the best we can do here).
                if (this.state.isSaved) {
                    analytics.event("save_for_later", "remove_item", TYPE);
                } else {
                    analytics.event("save_for_later", "add_item", TYPE);
                }

                console.error(e);
            });
    }

    render() {
        return <SaveForLater onClick={this.onClick} isSaved={this.state.isSaved} />;
    }
}

export default ToggleSaveSFLB;

ToggleSaveSFLB.propTypes = {
    productId: PropTypes.number.isRequired
};
